export const BUTTONS = {
  LOGOUT: "تسجيل خروج",
  SIGNUP: "تسجيل جديد",
};
